
var article = `
## Ingresando a la consola

1. Insertar un **USB booteable** con el *Windows actual*.
2. Una vez ejecutado el software del USB ingresar en la **reparación del equipo** y luego en **CMD** para poder ejecutar comandos.
3. En la **consola** probar con estas *2 posibles soluciones*.

## SOLUCIÓN N° 1:

>**x:\windows\system32>** diskpart

Mostrar una **lista** con los discos:

>**DISKPART>** list disk

Elegir el número que corresponda al *disco con problemas*:

>**DISKPART>** select **disk 0** *(por ejemplo)*

Se pueden ver los **volúmenes** con este comando:

>**DISKPART>** list volume *(sólo para tenerlo en cuenta)*

Mostrar una lista de todas las particiones del disco:

>**DISKPART>** list part

Seleccionar la *partición de arranque*. Si hay **una sola**, **seleccionar esa**:

>**DISKPART>** select part 1 *(por ejemplo)*

Ahora se verán los *detalles de la partición*:

>**DISKPART>** detail part

Se debería ver esta propiedad: **Active: No**.

Si es así, solamente se tipea *active* para activarla:

>**DISKPART>** active

Muestro los **detalles** nuevamente para ver si se **aplicaron los cambios**:

>**DISKPART>** detail part

Después de esto, salir de Diskpart:

>**DISKPART>** exit

Y reiniciar.

### SOLUCIÓN N° 2:

Ingresando a la **CMD** (*como se indica al principio*), hago lo siguiente:
 
Mostrar una **lista** con los discos:

>**DISKPART>** list disk

Elegir el número que corresponda al *disco con problemas*:

>**DISKPART>** select **disk 0** *(por ejemplo)*

Se pueden ver los **volúmenes** con este comando:

>**DISKPART>** list volume
  
**Supongamos** que en este punto tengo el *siguiente resultado*:

\`\`\`
Volume ###   Ltr   Label   	Fs   	Type     	Size 	Status	Info
--------------------------------------------------------------------------------------------------------------------------------------------
Volume 0      C    System  	NTFS 	Partition	579MB	Healthy     
Volume 1      E            	NTFS 	Partition	118GB	Healthy 
Volume 2      D    RECOVERY	FAT32	Removable	14GB 	Healthy 
\`\`\`

En este caso el **Volumen 0** se encarga del arranque. Cuya letra es la **C**.

Asique hay que crear los **archivos Boot**, para eso primero *salgo de Diskpart*:

>**DISKPART>** exit

Ingreso a **\\windows\\system32**

Y después ejecuto este comando:
  
> **x:\\windows\\system32>** bcdboot <b>e:</b>\\Windows /s **c:** /f BIOS *(los espacios deben respetarse tal cual)*

* Donde **bcdboot** es el *encargado de crear los archivos*.
* **E:** *reemplazar* por la letra que represente a *la partición con Windows*.
* **C:** *reemplazar* por la letra que represente a *la partición de arranque*.

* **Reiniciar**.
`;

export default article;